/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateGroupRequest
 */
export interface CreateGroupRequest {
    /**
     * PG名 半角英数のみ・スペース不可
     * @type {string}
     * @memberof CreateGroupRequest
     */
    paymentGroupName: string;
    /**
     * 上位グループコード
     * @type {string}
     * @memberof CreateGroupRequest
     */
    organizationCode: string;
    /**
     * 会社名 支払通知書の宛名用
     * @type {string}
     * @memberof CreateGroupRequest
     */
    companyName: string;
    /**
     * インボイス番号 T+13桁数字固定
     * @type {string}
     * @memberof CreateGroupRequest
     */
    invoiceNo: string;
    /**
     * 担当者名 支払通知書の宛名用
     * @type {string}
     * @memberof CreateGroupRequest
     */
    addressName: string;
    /**
     * 銀行名 100文字以内
     * @type {string}
     * @memberof CreateGroupRequest
     */
    bankName: string;
    /**
     * 支店名
     * @type {string}
     * @memberof CreateGroupRequest
     */
    branchName: string;
    /**
     * 支店番号 3桁数字
     * @type {string}
     * @memberof CreateGroupRequest
     */
    branchNum: string;
    /**
     * 普通・当座
     * @type {number}
     * @memberof CreateGroupRequest
     */
    bankAccountType: CreateGroupRequestBankAccountTypeEnum;
    /**
     * 口座番号 7桁数字
     * @type {string}
     * @memberof CreateGroupRequest
     */
    bankAccountNumber: string;
    /**
     * 口座名義
     * @type {string}
     * @memberof CreateGroupRequest
     */
    bankAccountName: string;
    /**
     * メール通知先 メールアドレス最大3件まで指定
     * @type {Array<string>}
     * @memberof CreateGroupRequest
     */
    notificationMails?: Array<string>;
    /**
     * 閲覧権限ユーザ メールアドレス最大3件まで指定
     * @type {Array<string>}
     * @memberof CreateGroupRequest
     */
    accessMails?: Array<string>;
    /**
     * メモ 最大100文字
     * @type {string}
     * @memberof CreateGroupRequest
     */
    note?: string;
}


/**
 * @export
 */
export const CreateGroupRequestBankAccountTypeEnum = {
    NORMAL: 1,
    CURRENT: 2
} as const;
export type CreateGroupRequestBankAccountTypeEnum = typeof CreateGroupRequestBankAccountTypeEnum[keyof typeof CreateGroupRequestBankAccountTypeEnum];


/**
 * Check if a given object implements the CreateGroupRequest interface.
 */
export function instanceOfCreateGroupRequest(value: object): value is CreateGroupRequest {
    if (!('paymentGroupName' in value) || value['paymentGroupName'] === undefined) return false;
    if (!('organizationCode' in value) || value['organizationCode'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('invoiceNo' in value) || value['invoiceNo'] === undefined) return false;
    if (!('addressName' in value) || value['addressName'] === undefined) return false;
    if (!('bankName' in value) || value['bankName'] === undefined) return false;
    if (!('branchName' in value) || value['branchName'] === undefined) return false;
    if (!('branchNum' in value) || value['branchNum'] === undefined) return false;
    if (!('bankAccountType' in value) || value['bankAccountType'] === undefined) return false;
    if (!('bankAccountNumber' in value) || value['bankAccountNumber'] === undefined) return false;
    if (!('bankAccountName' in value) || value['bankAccountName'] === undefined) return false;
    return true;
}

export function CreateGroupRequestFromJSON(json: any): CreateGroupRequest {
    return CreateGroupRequestFromJSONTyped(json, false);
}

export function CreateGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentGroupName': json['payment_group_name'],
        'organizationCode': json['organization_code'],
        'companyName': json['company_name'],
        'invoiceNo': json['invoice_no'],
        'addressName': json['address_name'],
        'bankName': json['bank_name'],
        'branchName': json['branch_name'],
        'branchNum': json['branch_num'],
        'bankAccountType': json['bank_account_type'],
        'bankAccountNumber': json['bank_account_number'],
        'bankAccountName': json['bank_account_name'],
        'notificationMails': json['notification_mails'] == null ? undefined : json['notification_mails'],
        'accessMails': json['access_mails'] == null ? undefined : json['access_mails'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function CreateGroupRequestToJSON(json: any): CreateGroupRequest {
    return CreateGroupRequestToJSONTyped(json, false);
}

export function CreateGroupRequestToJSONTyped(value?: CreateGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_group_name': value['paymentGroupName'],
        'organization_code': value['organizationCode'],
        'company_name': value['companyName'],
        'invoice_no': value['invoiceNo'],
        'address_name': value['addressName'],
        'bank_name': value['bankName'],
        'branch_name': value['branchName'],
        'branch_num': value['branchNum'],
        'bank_account_type': value['bankAccountType'],
        'bank_account_number': value['bankAccountNumber'],
        'bank_account_name': value['bankAccountName'],
        'notification_mails': value['notificationMails'],
        'access_mails': value['accessMails'],
        'note': value['note'],
    };
}

